/* eslint-disable */
import React from 'react'
import Select from 'react-select'

class SearchableCombo extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      arrayOfOptions: []
    }
  }

  handleChangeCombo = (arrayOfOptions) => {
    this.setState({arrayOfOptions})

    console.log(`Option selected:`, arrayOfOptions)
    this.props.getValueCombo(arrayOfOptions)
  }

  componentDidMount() {}

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (this.props.sendValue) {
      if (prevProps.sendValue !== this.props.sendValue) {
        this.setState({
          arrayOfOptions: this.props.sendValue
        })
      }
    }
  }

  render() {
    let {arrayOfOptions} = this.state

    return (
      <div>
        <label className={this.props.className ? this.props.className : ''}>
          {this.props.lableText}
          {this.props.force ? <span className="requireFiled">*</span> : ''}
        </label>
        <Select
          value={arrayOfOptions}
          onChange={this.handleChangeCombo}
          options={this.props.options}
          isMulti={this.props.isMulti}
          isClearable={this.props.isClearable}
          placeholder={this.props.placeholder}
          isDisabled={this.props.isDisabled}
        />
      </div>
    )
  }
}
export default SearchableCombo
